<!-- svelte-ignore a11y-label-has-associated-control -->
<!-- svelte-ignore a11y-missing-attribute -->

<div class="title has-text-centered">Your company</div>

<div class="field">
  <label class="label">Company name</label>
  <div class="control">
    <input class="input" type="text" placeholder="" bind:value={name} />
  </div>
</div>

<div class="field">
  <label class="label">Company website</label>
  <div class="control">
    <input
      class="input"
      type="text"
      placeholder=""
      bind:value={website}
    />
  </div>
</div>

{#if !selectedAddress}
  <label class="label">Postcode</label>
  <div class="field has-addons">
    <div class="control is-expanded">
      <input
        class="input"
        type="text"
        placeholder=""
        bind:value={postcode}
      />
    </div>
    <div class="control">
      <button
        class="button"
        on:click={lookup}
        class:is-loading={isLoadingLookup}>Find</button
      >
    </div>
  </div>

  {#if addresses}
    <div class="block" style="max-width:432px;">
      <p><b>Select your address</b></p>
      {#each addresses as address}
        <div
          style="overflow:hidden;white-space:nowrap;text-overflow:ellipsis;"
        >
          <a
            on:click={() => {
              selectedAddress = address;
            }}>{address.summaryline}</a
          >
        </div>
      {/each}
    </div>
  {/if}
{/if}

{#if selectedAddress}
  <hr />
  <div class="block is-size-4">Address</div>
  <div class="field">
    <label class="label">First line</label>
    <div class="control">
      <input
        class="input"
        type="text"
        placeholder=""
        bind:value={selectedAddress.addressline1}
      />
    </div>
  </div>

  <div class="field">
    <label class="label">Second line</label>
    <div class="control">
      <input
        class="input"
        type="text"
        placeholder=""
        bind:value={selectedAddress.addressline2}
      />
    </div>
  </div>

  <div class="field">
    <label class="label">Town</label>
    <div class="control">
      <input
        class="input"
        type="text"
        placeholder=""
        bind:value={selectedAddress.posttown}
      />
    </div>
  </div>

  <div class="field">
    <label class="label">Postcode</label>
    <div class="control">
      <input
        class="input"
        type="text"
        placeholder=""
        bind:value={selectedAddress.postcode}
      />
    </div>
  </div>
{/if}
<hr />
<div class="block">
  <button
    class="button is-primary"
    disabled={!isValid}
    on:click={submit}
    class:is-loading={isLoading}
  >
    Done
  </button>
</div>
{#if errorMessage}
  <div class="block">
    <div class="notification is-danger is-light">
      {errorMessage}
    </div>
  </div>
{/if}


<script lang="ts">
  import { goto } from "@sveltech/routify";
  import { logging } from '../../../lib/logging'; 
  import { appState } from "../../../lib/appState";

  let name : string, website : string, postcode : string;

  let addresses : FullAddress[];

  let selectedAddress : FullAddress | undefined;

  let isLoading = false, isLoadingLookup = false;

  let errorMessage : string;

  $: isValid = name && postcode && selectedAddress && selectedAddress.posttown;

  if ($appState.user!.company) {
    loadCompany();
  }

  async function loadCompany() {
    const company = await window.firebase
      .firestore()
      .doc("companies_v1/" + $appState.user!.company)
      .get()
      .then((doc) => doc.data() as Company_v1);

    name = company.name;
    website = company.website || "";
    postcode = company.postcode;
    selectedAddress = company.address?.postcode ? company.address : undefined;
  }

  async function submit() {
    isLoading = true;

    let company = {
      name,
      website,
      address: selectedAddress,
      postcode: selectedAddress?.postcode,
    };

    try {
      if ($appState.user!.company) {
        let result = await window.firebase.functions().httpsCallable('api-account-updatecompany')({ id: $appState.user!.company, company } as UpdateCompanyParams);
        $appState.company = result.data.company;
      } else {
        let result = await window.firebase.functions().httpsCallable('api-account-createcompany')({ company } as CreateCompanyParams);
        $appState.user!.company = result.data.id;
        $appState.company = result.data.company;
      }

      isLoading = false;

      $goto("/business");
    } catch (err: any) {
      isLoading = false;
      logging.report(err.toString());
      errorMessage = err.toString();
    }
  }

  async function lookup() {
    isLoadingLookup = true;

    const apiKey = "PCWNV-535F5-P59NX-P5G2A";
    const country = "UK";

    fetch(
      `https://ws.postcoder.com/pcw/${apiKey}/address/${country}/${encodeURIComponent(
        postcode
      )}?format=json&lines=2&identifier=business_setup`
    )
      .then((response) => {
        return response.json();
      })
      .then(
        (data) => {
          isLoadingLookup = false;
          addresses = data;
        },
        (reason: any) => {
          // error
          logging.report(reason.toString());
          isLoadingLookup = false;
        }
      );
  }
</script>
